import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'i18n'
import { formatTime } from 'utils/date'
import moment from 'moment-timezone'
import TimePicker from 'react-times'
import { Icon } from 'components/styled/icon'
import { InputStyle } from 'components/form-components/styled-text-input'
import 'react-times/css/material/default.css'

const propTypes = {
  onChange: PropTypes.func.isRequired,
  timezone: PropTypes.string,
  time: PropTypes.string,
  resetTimePicker: PropTypes.bool.isRequired,
  defaultTime: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

const defaultProps = {
  value: undefined,
  time: undefined,
  timezone: undefined,
  defaultTime: formatTime(moment()),
}

// resetTimePicker prop is used here as a key prop to remount the component when clearing endTime
// or when changing timezone so the clock handles point to the correct time
// TODO: Check this key hack

export const TimePickerContainer = styled.div`
  ${InputStyle};
  column-gap: ${({ theme }) => theme.space.s8};
  display: flex;
  align-items: center;
  cursor: pointer;

  && {
    & > * {
      box-shadow: none !important;
      transition: none !important;
      transform: none !important;
    }

    .react_times_button .wrapper {
      transform: none !important;
    }

    .time_picker_modal_container {
      overflow: visible;
      top: 1.4rem;
      left: -6rem;
      width: auto;
      margin-top: 1rem;

      ${({ theme }) => theme.mediaQuery.tablet} {
        left: ${({ theme }) => `-${theme.space.s160}`};

        .time_picker_modal_header::after {
          left: 65%;
        }
      }
    }

    .outside_container.active .time_picker_modal_container {
      z-index: 11;
    }

    .picker_pointer,
    .pointer_drag,
    .picker_pointer.animation,
    .picker_center {
      background-color: ${({ theme }) => theme.color.primary110} !important;
    }

    .time_picker_modal_header {
      background-color: ${({ theme }) => theme.color.white} !important;
      color: ${({ theme }) => theme.color.bodyText} !important;
      border-bottom: 1px solid ${({ theme }) => theme.color.grey20};

      &::after {
        position: absolute;
        left: 30%;
        top: -1rem;
        width: 0;
        height: 0;
        content: '';
        border-left: 2rem solid transparent;
        border-right: 2rem solid transparent;
        border-bottom: ${({ theme }) => theme.space.s20} solid
          ${({ theme }) => theme.color.white} !important;
      }
    }

    .time_picker_preview {
      box-shadow: none;
      height: ${({ theme }) => theme.space.s40};
      width: 100%;

      .wrapper {
        background-color: ${({ theme }) => theme.color.grey07};
      }
      .preview_container {
        position: relative;
        display: flex;
        align-items: center;
        padding-left: 0;
        column-gap: ${({ theme }) => theme.space.s8};
        height: ${({ theme }) => theme.space.s40};
        background-color: ${({ theme }) => theme.color.grey07};

        svg {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          height: ${({ theme }) => theme.space.s20};
          width: ${({ theme }) => theme.space.s20};
          position: relative;
          top: 0;

          padding: 0px;
          column-gap: ${({ theme }) => theme.space.s8};
          path {
            fill: ${({ theme }) => theme.color.bodyText};
          }
        }
      }
    }
  }
`

const StyledIcon = styled(Icon)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-left: ${({ theme }) => theme.space.s12};
  width: ${({ theme }) => theme.space.s40};
  height: ${({ theme }) => theme.space.s40};
  gap: 10px;
`
export class TimePickerInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      focused: false,
      renderPicker: false,
    }

    this.onClickContainer = this.onClickContainer.bind(this)
    this.onTimeChange = this.onTimeChange.bind(this)
    this.onClearFocus = this.onClearFocus.bind(this)
  }

  componentDidMount() {
    const { time, defaultTime } = this.props
    const t = time || defaultTime
    this.setValues(t)
  }

  componentDidUpdate(prevProps) {
    const { resetTimePicker, defaultTime } = this.props
    if (prevProps.resetTimePicker !== resetTimePicker && resetTimePicker) {
      this.setValues(defaultTime)
    }
  }

  onTimeChange(time) {
    const { timezone, value, onChange } = this.props
    const { minute, hour } = time
    const date = moment(value).format('YYYY-MM-DD')
    const passValue = moment.tz(`${date} ${hour}:${minute}`, timezone)
    onChange(passValue)
  }

  onClearFocus() {
    const { time } = this.props
    if (!time) {
      this.setState({ renderPicker: false })
    }
    this.setState({ focused: false })
  }

  onClickContainer() {
    this.setState({ renderPicker: true, focused: true })
  }

  setValues() {
    const { value } = this.props
    this.setState({ renderPicker: false })

    if (!value) {
      this.setState({ focused: false })
    }
  }

  render() {
    const { time, resetTimePicker, defaultTime } = this.props
    const { focused, renderPicker } = this.state

    if (!time && !renderPicker) {
      return (
        <TimePickerContainer onClick={this.onClickContainer}>
          <StyledIcon type="access_time" size="s20" />
          <div>--:--</div>
        </TimePickerContainer>
      )
    }

    return (
      <TimePickerContainer>
        <TimePicker
          onTimeChange={this.onTimeChange}
          onFocusChange={this.onClearFocus}
          key={resetTimePicker}
          time={time || defaultTime}
          focused={focused}
          draggable={false}
        />
      </TimePickerContainer>
    )
  }
}

TimePickerInput.propTypes = propTypes
TimePickerInput.defaultProps = defaultProps

export default connect(mapLanguageToComponentProps())(TimePickerInput)
